<template>
  <div>
    <ul class="nav nav-mobile-menu">
      <base-dropdown tag="li" no-auto-close>
              <template #title v-if="">
                <b-icon icon="bell-fill" aria-hidden="true"></b-icon>
                {{ translate('unpaidList') }}
                <b class="caret"></b>
                <span class="notification" style="color: red;">{{ totalNotifications}}</span>
              </template>

              <!-- Notification Items -->
              <div
                v-for="(notification, index) in ekubNotification"
                :key="index"
                class="dropdown-item"
                style="border-bottom: 3px solid rgba(240, 206, 13, 0.937);"
                @click.stop
              >
                <div class="row">
                  <div class="col-md-12">
                    <h6 style="color:rgb(37, 91, 48)">
                      <b-icon
                        style="color: rgba(240, 206, 13, 0.937)"
                        icon="people-fill"
                        aria-hidden="true"
                      ></b-icon>
                      {{ notification.memberFullName }}
                    </h6>
                  </div>
                  <div class="col-md-12">
                    <h6 style="color:rgb(37, 91, 48)">
                      <b-icon
                        style="color: rgba(240, 206, 13, 0.937)"
                        icon="telephone-fill"
                        aria-hidden="true"
                      ></b-icon>
                      {{ notification.memberPhoneNumber }}
                    </h6>
                  </div>
                  <div class="col-md-12">
                    <h6 style="color:rgb(37, 91, 48)">
                      <b-icon
                        style="color: rgba(240, 206, 13, 0.937)"
                        icon="tags-fill"
                        aria-hidden="true"
                      ></b-icon>
                      {{ notification.ekubType }}
                    </h6>
                  </div>
                  <div class="col-md-12">
                    <h6 style="color:rgb(37, 91, 48)">
                      <b-icon
                        style="color: rgba(240, 206, 13, 0.937)"
                        icon="currency-dollar"
                        aria-hidden="true"
                      ></b-icon>
                      {{ notification.amountPerCycle }}
                    </h6>
                  </div>
                </div>
              </div>

              <!-- Pagination Controls -->
              <div class="pagination-container">
                <button
                  class="btn btn-sm btn-primary"
                  @click.stop="fetchPreviousPage"
                  :disabled="currentPage === 0"
                >
                  <
                </button>
                <span class="mx-2">Page {{ currentPage+1 }} of {{ totalPages }}</span>
                <button
                  class="btn btn-sm btn-primary"
                  @click.stop="fetchNextPage"
                  :disabled="currentPage === totalPages"
                >
                  >
                </button>
              </div>
            </base-dropdown>

      <li class="nav-item">
        <a @click="ViewAccount" class="nav-link">
          {{ translate('account') }}
        </a>
      </li>
      <li class="nav-item">
        <a @click="signOut" class="nav-link">
          {{ translate('logout') }}
        </a>
      </li>
      <li class="nav-item">
              <a class="nav-link">
                Language
              </a>
            </li>
      <li class="nav-item  ">
            <select  @change="changeLanguage($event.target.value)" 
              class="nav-link" 
              style="border: none;color:#fff ;background: gray ;" 
              :value="currentLanguage">
              <option style="color:#fff ;background: gray ;font-size: 8px;"  value="en">English</option>
              <option style="color:#fff ;background: grey ; font-size: 8px;"  value="am">Amharic (አማርኛ)</option>
              <!-- <option value="am">French (Français)</option> -->
            </select>
          </li>
    </ul>

    <!-- Account Modal -->
    <div class="row">
      <b-modal id="modal-center-account-mob" hide-footer :title="translate('account')" content-class="shadow">
        <template #modal-header="{ close }">
          <h5>{{ translate('account') }}</h5>
          <p class="h5 mb-2">
            <b-icon icon="x-square" class="close-icon" @click="close(); clearData();"></b-icon>
          </p>
        </template>
        <b-row no-gutters>
          <b-col xs="12" class="profile-icon">
            <b-icon icon="person-bounding-box"></b-icon>
          </b-col>
        </b-row>
        <b-row no-gutters class="mt-2">
          <b-col xs="6" class="left-profile">
            <b-row class="left-prof">{{ translate('firstName') }}</b-row>
            <b-row class="left-prof">{{ translate('lastName') }}</b-row>
            <b-row class="left-prof">{{ translate('username') }}</b-row>
            <b-row class="left-prof">{{ translate('phoneNumber') }}</b-row>
            <b-row class="left-prof">{{ translate('email') }}</b-row>
            <!-- <b-row class="left-prof">{{ translate('accountNumber') }}</b-row> -->
          </b-col>
          <b-col xs="4" class="right-profile">
            <b-row class="right-prof">{{ accountData.firstName }}</b-row>
            <b-row class="right-prof">{{ accountData.lastName }}</b-row>
            <b-row class="right-prof">{{ accountData.username }}</b-row>
            <b-row class="right-prof">{{ accountData.phoneNumber }}</b-row>
            <b-row class="right-prof">{{ accountData.email }}</b-row>
            <!-- <b-row class="right-prof">{{ accountData.accountNumber }}</b-row> -->
          </b-col>
        </b-row>
        <b-row no-gutters class="mt-2 changePWD">
          <b-button @click="changePassword()" class="btn-outline-primary" size="sm" style="font-weight: 700;">
            {{ translate('changePassword') }}
          </b-button>
        </b-row>
      </b-modal>
    </div>

    <!-- Change Password Modal -->
    <div class="row">
      <b-modal id="modal-center-changePwd-mob" hide-footer :title="translate('changePassword')" content-class="shadow">
        <template #modal-header="{ close }">
          <h5>{{ translate('changePassword') }}</h5>
          <p class="h5 mb-2">
            <b-icon icon="x-square" class="close-icon" @click="close(); clearData();"></b-icon>
          </p>
        </template>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(submitChangeForm)">
            <b-row no-gutters>
              <b-col md="12" style="justify-content: center; align-items: center">
                <Vinput
                  inputType="password"
                  :modelValue="addData.oldPassword"
                  @update:modelValue="(newValue) => (addData.oldPassword = newValue)"
                  :rules="{ required: true }"
                  id="text-oldPassword"
                  name="text-oldPassword"
                  :label="translate('oldPassword')"
                  class="mb-1 mr-sm-2"
                />
              </b-col>
              <b-col md="12" style="justify-content: center; align-items: center">
                <Vinput
                  inputType="password"
                  :modelValue="addData.newPassword"
                  @update:modelValue="(newValue) => (addData.newPassword = newValue)"
                  :rules="{ required: true }"
                  id="text-newPassword"
                  name="text-newPassword"
                  :label="translate('newPassword')"
                  class="mb-1 mr-sm-2"
                />
              </b-col>
              <b-col md="12" style="justify-content: center; align-items: center">
                <Vinput
                  inputType="password"
                  :modelValue="addData.confirmPassword"
                  @update:modelValue="(newValue) => (addData.confirmPassword = newValue)"
                  :rules="{ required: true }"
                  id="text-confirmPassword"
                  name="text-confirmPassword"
                  :label="translate('confirmPassword')"
                  class="mb-1 mr-sm-2"
                />
              </b-col>
              <b-col class="mt-2">
                <b-button type="submit" variant="primary">{{ translate('submit') }}</b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
    </div>
  </div>
</template>
<script>
import Vinput from 'src/components/Inputs/Vinput.vue'
import { translate, setLanguage } from 'src/i18n.js';  // Importing the translation functions
  export default {
    components: {
      Vinput
    },
    data () {
      return {
        currentLanguage:localStorage.getItem('lang')||'en',
        ekubNotification: [],
        activeNotifications: false,
        contractNotification: [],
        accountData:{
          firstName: "",
          lastName: "",
          username: "",
          email: "",
          phoneNumber: "",
          accountNumber: ""
        },
        addData: {
          userId: sessionStorage.getItem("ID"),
          newPassword: "",
          oldPassword: "",
          confirmPassword: ""
        }
      }
    },
    mounted(){
      //this.getTenantsWithPaymentStatus();
      this.ViewNotification(sessionStorage.getItem("ID"));
    },
    methods: {
      translate,
      
      changeLanguage(lang) {
        this.currentLanguage = lang; // Update the currentLanguage variable
        localStorage.setItem('lang', lang); // Persist the selected language in local storage
        
        setLanguage(lang);
        this.$forceUpdate();
        window.location.reload();
      },
      signOut(){
          this.$store.dispatch('Logout')
          .then(()=>{
              this.$router.push('/');
          })
          .catch(error =>{
              //console.log(error);
          });
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      getTenantsWithPaymentStatus(){
          this.$store.dispatch('getTenantsWithPaymentStatus', {userId: sessionStorage.getItem("ID"), paymentStatus: "Unpaid"})
          .then(response=>{
              this.items = response.data;
              //console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              //console.log(error);
          })
      },
      ViewAccount(){
        this.$store.dispatch('getAccountByID', {id: sessionStorage.getItem("ID")})
          .then(response=>{
            this.accountData.firstName = response.data.firstName;
            this.accountData.lastName = response.data.lastName;
            this.accountData.username = response.data.username;
            this.accountData.email = response.data.email;
            this.accountData.phoneNumber = response.data.phoneNumber;
            this.accountData.accountNumber = response.data.accountNumber;
            //console.log("some", this.accountData);
            this.$bvModal.show('modal-center-account-mob');
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              //console.log(error);
          })
      },
      fetchPreviousPage() {
  if (this.currentPage > 0) {
    this.currentPage--;  // Decrement the page
    this.ViewNotification(sessionStorage.getItem("ID"), this.currentPage+1);  // Pass the updated page
  }
},

fetchNextPage() {
  if (this.currentPage < this.totalPages-1) {
    this.currentPage++;  // Increment the page
    this.ViewNotification(sessionStorage.getItem("ID"), this.currentPage+1);  // Pass the updated page
  }
},
      ViewNotification(ID, page = 1) {
  const userRole = sessionStorage.getItem("user_role");
  let apiCall = "";
  if (["SUPER_ADMIN", "SUPER_MANAGER", "SUPER_FINANCE", "SUPER_USER"].includes(userRole)) {
    apiCall = "getOverdueEkubUnpaidNotification";
  } else if (["ADMIN", "MANAGER", "FINANCE", "USER"].includes(userRole)) {
    apiCall = "getOverdueEkubUnpaidNotificationForUser";
  }

  this.$store
    .dispatch(apiCall, {
      userId: sessionStorage.getItem("ID"),
      superUserId: parseInt(sessionStorage.getItem("superID")),
      page: page, // Pass the current page to the API
    })
    .then((response) => {
      const { notification, currentPage, totalPages, totalItems } = response.data;
      this.ekubNotification = notification;
      this.currentPage = currentPage;
      this.totalPages = totalPages;
      this.totalNotifications = totalItems;
    })
    .catch((error) => {
      this.$notifications.notify({
        message: error.response.data,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "danger",
      });
    });
},
    fetchNotifications(page) {
      this.ViewNotification(sessionStorage.getItem("ID"), page);
    },
      changePassword(){
        this.$bvModal.show('modal-center-changePwd-mob');
      },
      checkPasswordComplexity(password){
        let validationRegex = [
            { regex: /.{6,}/ }, // min 8 letters,
            { regex: /[0-9]/ }, // numbers from 0 - 9
            { regex: /[a-z]/ }, // letters from a - z (lowercase)
            { regex: /[A-Z]/}, // letters from A-Z (uppercase),
            { regex: /[^A-Za-z0-9]/} // special characters
        ]

        var checkValid =  true;
        validationRegex.forEach((item, i) => {
          var isValid = item.regex.test(password);
          checkValid = isValid
          return
        }); 
        return checkValid;
      },
      submitChangeForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to change your password?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              if(this.addData.newPassword === this.addData.confirmPassword){
                //console.log("password", this.addData.newPassword, this.checkPasswordComplexity(this.addData.newPassword));
                if(this.checkPasswordComplexity(this.addData.newPassword)){
                  this.$store.dispatch('changePassword', this.addData)
                  .then(response=>{
                      this.$notifications.notify(
                        {
                          message: `<span>Password successfully changed.</span>`,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'success'
                        })
                        this.$bvModal.hide('modal-center-changePwd-mob');
                        this.$bvModal.hide('modal-center-account-mob');
                        this.clearData();
                  })
                  .catch(error=>{
                     // console.log(error);
                      this.$notifications.notify(
                        {
                          message: error.response.data,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'danger'
                        })
                  })
                }else{
                  this.$notifications.notify(
                  {
                    message: `<span>Not valid password.</span>`,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
                }
              }else{
                this.$notifications.notify(
                {
                  message: `<span>Password did not match.</span>`,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              }
            }
        })
        .catch(error=>{
           //console.log(error)
        })
      }
    }
  }
</script>
<style scoped>
.nav-item{
  cursor: pointer;
}
.lang{
    color:#fff !important;
    background-color: rgb(66, 66, 70) !important;
  }
.profile-icon{
  font-size: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(240, 206, 13, 0.937);
  margin-right: 40px;
}
.left-profile{
  text-align: right;
  color: rgb(37, 91, 48);
}
.right-profile{
  border-left: 2px solid rgba(240, 206, 13, 0.937);
  padding-left: 40px;
}
.left-prof{
  justify-content: right;
  text-align: right !important;
  margin-right: 20px;
}
.right-prof{
  justify-content: left;
  text-align: left !important;
  margin-right: 5px;
}
@media (min-width: 768px) {
  .profile-icon{
    padding-right: 40px;
  }
}
.changePWD{
    display: flex;
    justify-content: center;
    align-items: center;
}
@media (min-width: 768px) {
 
  .changePWD{
    padding-right: 40px;
  }
}
.language-select {
  border: none;
  background-color: #d3d3d3; /* Grey background */
  color: #FFFFFF; /* White text */
  padding: 5px; /* Optional for better spacing */
  border-radius: 4px; /* Optional for rounded corners */
}
</style>

